<tt-page *ngIf="page">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-input ttLabel="firstname" [(ttModel)]="page.firstname" ttRequired ttShowClearButton></tt-input>
        <tt-input ttLabel="lastname" [(ttModel)]="page.lastname" ttRequired ttShowClearButton></tt-input>
        <tt-input ttLabel="cellphone" [(ttModel)]="page.cellphone" ttRequired ttShowClearButton></tt-input>
        <tt-input ttLabel="email" [(ttModel)]="page.email" ttRequired ttShowClearButton></tt-input>
        <tt-input ttLabel="private_car_regno" [(ttModel)]="page.private_car_regno" ttShowClearButton></tt-input>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="page.isactive"></tt-checkbox>
        <tt-button-save ttText="srcrew_save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
    </tt-card>
</tt-page>
